"use client";

import { m, LazyMotion, domAnimation } from "motion/react";

const Collapse = ({ children, open, rest }: any) => {
  const animate: any = {
    transition: { type: "tween" },
    height: open ? "auto" : 0,
    //opacity: open ? 1 : .5
  };

  return (
    <LazyMotion features={domAnimation} strict>
      <div aria-expanded={open} {...rest}>
        <m.div
          style={{ overflow: "hidden" }}
          initial={{ height: 0, opacity: 1 }}
          animate={animate}
          exit={{ height: 0, opacity: 1 }}
        >
          {children}
        </m.div>
      </div>
    </LazyMotion>
  );
};

export default Collapse;
